function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("tspan", {
  x: -12.624,
  y: 0
}, "\uDBC0\uDEB5");

function SvgFullHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9066"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 60 \\u2013 152"
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": "\\uDBC0\\uDEB5",
    transform: "translate(13 21)",
    style: {
      fill: "#ea9e2b",
      fontSize: 22,
      fontFamily: "Gilroy-SemiBold,SF Compact",
      fontWeight: 600
    }
  }, _ref2)), /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 60 \\u2013 153"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7220",
    d: "M-10.137-10.205a8.954 8.954 0 0 0 1.145 4.294 16.986 16.986 0 0 0 3.241 4.134 32.294 32.294 0 0 0 4.942 3.84A3.5 3.5 0 0 0-.37 2.3a1.027 1.027 0 0 0 .412.1 1.027 1.027 0 0 0 .413-.1A3.5 3.5 0 0 0 .9 2.063a32.3 32.3 0 0 0 4.937-3.84 17.09 17.09 0 0 0 3.246-4.134 8.925 8.925 0 0 0 1.15-4.294 6.89 6.89 0 0 0-.444-2.515 6.028 6.028 0 0 0-1.236-1.98A5.464 5.464 0 0 0 6.7-15.992a5.844 5.844 0 0 0-2.307-.452 5.194 5.194 0 0 0-2.545.614A5.08 5.08 0 0 0 .043-14.2a5.068 5.068 0 0 0-1.791-1.627 5.181 5.181 0 0 0-2.552-.617 5.84 5.84 0 0 0-2.306.452 5.466 5.466 0 0 0-1.86 1.292A5.971 5.971 0 0 0-9.7-12.72a6.949 6.949 0 0 0-.437 2.515zm1.854-.005a4.823 4.823 0 0 1 .528-2.307 3.926 3.926 0 0 1 1.435-1.539 3.9 3.9 0 0 1 2.066-.552 3.7 3.7 0 0 1 1.617.327 4.006 4.006 0 0 1 1.159.822 7.127 7.127 0 0 1 .807.987 1.638 1.638 0 0 0 .364.425.59.59 0 0 0 .35.113.549.549 0 0 0 .345-.117 2.081 2.081 0 0 0 .369-.42 9.1 9.1 0 0 1 .828-.978 4.113 4.113 0 0 1 1.149-.826 3.594 3.594 0 0 1 1.607-.332 3.923 3.923 0 0 1 2.071.552 3.878 3.878 0 0 1 1.436 1.539 4.859 4.859 0 0 1 .523 2.307 6.566 6.566 0 0 1-.662 2.8A12.993 12.993 0 0 1 5.9-4.624a22.38 22.38 0 0 1-2.6 2.632A30.742 30.742 0 0 1 .239.334a.554.554 0 0 1-.2.1.553.553 0 0 1-.2-.1 30.742 30.742 0 0 1-3.057-2.326 22.349 22.349 0 0 1-2.6-2.632 13 13 0 0 1-1.8-2.789 6.566 6.566 0 0 1-.666-2.798z",
    transform: "translate(13 21)",
    style: {
      fill: "#5b646b"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullHeart);
export default __webpack_public_path__ + "static/media/fullHeart.088f81de.svg";
export { ForwardRef as ReactComponent };